import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

/**
 * ResultToolbar — thin bar above the photo carousel. Now hosts just
 * the Back button; Replace and Add-Photo moved into the compact
 * `PhotoActionRow` that sits directly under the carousel so both
 * photo-mutation affordances live in one obvious place (mirrors the
 * "Replace / Delete / Add Photo" pattern users recognize from other
 * plant apps).
 */
export default function ResultToolbar({ onBack }) {
  const { t } = useTranslation();
  return (
    <div className="mx-5 mt-1 mb-2 flex items-center gap-3">
      <button
        onClick={onBack}
        data-testid="back-button"
        aria-label={t("result.backAria")}
        className="w-9 h-9 rounded-full bg-white border border-[#E8E5DF] text-leaf-ink flex items-center justify-center hover:bg-parchment transition"
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
}
